export default __webpack_public_path__ + "static/media/roadMap.9a5f6721.png";